/* @generated */

// ../src/badges/accessory_badge/accessory_badge.tsx
import { useTheme } from "@dropbox/dig-foundations";
import classNames from "classnames";
import * as React from "react";
import { Badge } from "@dropbox/dig-components/badge";
var AccessoryBadgeMigrated = ({
  className,
  children,
  inverse,
  status,
  ...rest
}) => {
  const inverseClassName = useTheme().getInverseProps().className;
  const cls = classNames(className, {
    [inverseClassName]: inverse
  });
  return /* @__PURE__ */ React.createElement(Badge, { ...rest, className: cls, variant: status }, children);
};
var AccessoryBadge = ({
  inverse,
  children,
  status,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement(AccessoryBadgeMigrated, { inverse, status, ...rest }, children);
};
AccessoryBadge.displayName = "AccessoryBadge";

// ../src/badges/notification_badge/notification_badge.tsx
import * as React2 from "react";
import { Badge as Badge2 } from "@dropbox/dig-components/badge";
var NotificationBadgeMigrated = ({
  className,
  children,
  status = "alert",
  ...rest
}) => {
  return /* @__PURE__ */ React2.createElement(Badge2, { className, variant: status, ...rest }, children);
};
var NotificationBadge = ({ children, ...rest }) => {
  return /* @__PURE__ */ React2.createElement(NotificationBadgeMigrated, { ...rest }, children);
};
export {
  AccessoryBadge,
  NotificationBadge
};
